<template>
  <basic-container>
    <div class="search_group">
      <el-date-picker v-model="searchStartTime"
                      size="small"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      start-placeholder="生效时间开始"
                      end-placeholder="生效时间结束"></el-date-picker>
      <el-date-picker v-model="searchDeadTime"
                      size="small"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      start-placeholder="过期时间开始"
                      end-placeholder="过期时间结束"></el-date-picker>
      <el-select @change="searchAct"
                 v-model="productType"
                 size="small"
                 clearable
                 placeholder="授权类型">
        <el-option v-for="item in productTypeList"
                   :key="item.id"
                   :label="item.typeName"
                   :value="item.id"></el-option>
      </el-select>
      <el-select @change="searchAct"
                 v-model="searchStatus"
                 size="small"
                 clearable
                 placeholder="状态">
        <el-option label="授权中"
                   :value="1"></el-option>
        <el-option label="过期中"
                   :value="2"></el-option>
        <el-option label="退款失败"
                   :value="3"></el-option>
        <el-option label="未激活"
                   :value="4"></el-option>
        <el-option label="激活未授权"
                   :value="5"></el-option>
      </el-select>
      <el-input :maxlength="30"
                v-model="deptName"
                size="small"
                placeholder="企业名称"></el-input>
      <el-input :maxlength="30"
                v-model="authId"
                size="small"
                placeholder="授权码"></el-input>
      <el-input :maxlength="30"
                v-model="deviceName"
                size="small"
                placeholder="设备名称"></el-input>
      <el-input :maxlength="30"
                v-model="uid"
                size="small"
                placeholder="UID"></el-input>
      <el-input :maxlength="30"
                v-model="userAccount"
                size="small"
                placeholder="绑定授权账号"></el-input>
      <el-button @click="searchAct"
                 icon="el-icon-search"
                 size="small"
                 type="primary">搜索</el-button>
      <el-button @click="exportList"
                 v-auth="'memberAuth_export'"
                 icon="el-icon-download"
                 size="small"
                 type="primary">导出</el-button>
    </div>
    <el-table :cell-style="{'text-align':'center'}"
              :header-cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              v-loading="listLoading"
              element-loading-text="加载中"
              border
              :data="tableData">
      <el-table-column fixed
                       prop="deptName"
                       label="企业名称"
                       width="130"></el-table-column>
      <el-table-column prop="id"
                       label="授权码"
                       width="200"></el-table-column>
      <el-table-column prop="productTypeName"
                       label="授权类型"
                       width="120"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{scope.row.status==1?'授权中':scope.row.status==2?'过期中':scope.row.status==3?'退款失败':scope.row.status==4?'未激活':scope.row.status==5?'激活未授权':''}}
        </template>
      </el-table-column>
      <el-table-column prop="periodValueName"
                       label="授权周期"></el-table-column>
      <el-table-column prop="deviceName"
                       label="设备名称"
                       width="130"></el-table-column>
      <el-table-column prop="uid"
                       label="UID"
                       width="200"></el-table-column>
      <el-table-column prop="userAccount"
                       label="绑定授权账号"
                       width="120"></el-table-column>
      <el-table-column prop="activeDate"
                       label="授权生效时间"
                       width="180"></el-table-column>
      <el-table-column prop="expireDate"
                       label="授权过期时间"
                       width="180"></el-table-column>
    </el-table>
    <div class="table_pagination">
      <el-pagination class="app-pagination"
                     background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="pageNo"
                     :page-sizes="pageSizeArr"
                     :page-size="pageSize"
                     :layout="paginationLayout"
                     :total="totalEl">
      </el-pagination>
    </div>
  </basic-container>
</template>

<script>
import { listProductType, authList } from '@/api/member'
import { exportLicense } from '@/services'
import pagination from '@/util/mixins/pagination'
export default {
  mixins: [pagination],
  data () {
    return {
      productTypeList: [], // 授权类型列表
      searchStartTime: '', // 开始时间
      searchDeadTime: '', // 过期时间
      productType: '', // 授权类型
      searchStatus: '', // 状态1待开票 2已开票 3失败
      deptName: '', // 企业名称
      authId: '', // 授权码
      uid: '', // uid
      userAccount: '', // 绑定账号
      deviceName: '' // 设备名称
    }
  },
  mounted () {
    listProductType().then(res => {
      if (res.data.code === 200) {
        this.productTypeList = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      // 地址栏传入过来的id进行查询
      this.authId = this.$route.query.id ? this.$route.query.id : ""

      this.listLoading = true
      let postData = {
        activeDateBegin: this.searchStartTime ? this.searchStartTime[0] : '',
        activeDateEnd: this.searchStartTime ? this.searchStartTime[1] : '',
        expireDateBegin: this.searchDeadTime ? this.searchDeadTime[0] : '',
        expireDateEnd: this.searchDeadTime ? this.searchDeadTime[1] : '',
        productType: this.productType,
        status: this.searchStatus,
        deptName: this.deptName.trim(),
        id: this.authId.trim(),
        deviceName: this.deviceName.trim(),
        uid: this.uid.trim(),
        userAccount: this.userAccount.trim(),
        current: this.pageNo,
        size: this.pageSize
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      authList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 导出
    exportList () {
      let postData = {
        activeDateBegin: this.searchStartTime ? this.searchStartTime[0] : '',
        activeDateEnd: this.searchStartTime ? this.searchStartTime[1] : '',
        expireDateBegin: this.searchStartTime ? this.searchDeadTime[0] : '',
        expireDateEnd: this.searchStartTime ? this.searchDeadTime[1] : '',
        productType: this.productType,
        status: this.searchStatus,
        deptName: this.deptName.trim(),
        id: this.authId.trim(),
        deviceName: this.deviceName.trim(),
        uid: this.uid.trim(),
        userAccount: this.userAccount.trim()
      }
      exportLicense(postData)
    }
  }
}
</script>
